export default "__VITE_ASSET__CtwwbXpk__"